export const getConsentObject = (facebook, standard, google, ga) => ({ facebook, standard, google, ga });
export const getObjectConsent = (consent) =>
  getConsentObject(consent.facebook, consent.standard, consent.google, consent.ga);
export const getSingleValueConsent = (consent) => getConsentObject(consent, consent, consent, consent);
export const setCMPData = (state, CMPData) => {
  state.CMPData = CMPData;
};
export const setConsentsFromConfig = (state, config) => {
  const consent = config.consent;
  if (typeof consent === "boolean") setCMPData(state, getSingleValueConsent(consent));
  else if (typeof consent === "object") setCMPData(state, getObjectConsent(consent));
};

export const allowWaitGAConfig = (consent) =>
  typeof consent === "boolean" ? consent !== false : !consent || consent.ga === true;
export const setAnalyticsWait = (state, config) => {
  state.analyticsWait = config.analyticsWait && (allowWaitGAConfig(config) || state.CMPData.ga);
};
